"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _competitionColumn = require("@/api/competitionColumn/competitionColumn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
;
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default,
    fileUpload: _index.default
  },
  data: function data() {
    return {
      accept: ".png,.jpg,.pdf",
      propImg: "",
      contestTypeList: [],
      //所属比赛
      schoolIdList: [],
      //所属学校
      courseLevelList: [],
      // 层次
      yearList: [],
      // 年份
      coTypeList: [],
      //比赛类型
      form: {
        contestLevelId: "",
        contestNameId: "",
        contestTypeId: "",
        createBy: "",
        // 创建人id
        createTime: "",
        // 创建时间
        id: "",
        isDelete: 0,
        provinceId: this.$store.getters.provinceId,
        schoolId: "",
        status: "",
        //发布状态
        updateBy: "",
        //修改人
        updateTime: "",
        //	更新时间
        workContent: "",
        workCoverImg: "",
        workName: "",
        year: "" //年份
      },
      rules: {
        courseName: [{
          required: true,
          message: "请输入项目名称。",
          trigger: "blur"
        }],
        hostTeacher: [{
          required: true,
          message: "请选择主持教师。",
          trigger: "change"
        }],
        freeLoginLink: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }, {
          type: 'url',
          message: '请输入以http://或https://开头的网址',
          trigger: ['blur', 'change']
        }],
        courseLink: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }, {
          type: 'url',
          message: '请输入以http://或https://开头的网址',
          trigger: ['blur', 'change']
        }],
        courseSource: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }],
        studentNumber: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    isnumber: function isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      return val;
    },
    // 课程封面
    successUpLoad: function successUpLoad(e) {
      this.form.imageUrl = e.ossOriUrl;
    },
    // 提交
    submit: function submit(v) {
      var _this = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _competitionColumn.workUpload)(_this.form).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success("操作成功。");
              _this.$router.push("/competition/index");
            }
          });
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/competition/index");
    }
  },
  created: function created() {
    this.form = this.$route.query;
    this.propImg = this.$route.query.imageUrl;
    // 层次
    this.courseLevelList = this.$store.getters.wCourseLevel;
    // 年份
    this.yearList = this.$store.getters.wYearListAll;
    // 比赛类型
    this.coTypeList = this.$store.getters.wContestType;
    // 所属比赛
    this.contestTypeList = this.$store.getters.wContestName;
  }
};